<template>
    <div class="home-wrap">
        <sidebar ref="sideBar" :sidebarList="$store.state.permissionInfo.sidebarList"></sidebar>
        <div class="main-wrap" :class="$store.state.isCollapse?'coll-main':'open-main'">
            <div class="change-nav fl mr10" @click="changeNavView">
                <i class="ft30 fl mr20 iconfont" :class="$store.state.isCollapse?'icon-zhankai':'icon-shouqi'"></i>
            </div>
            <!-- <headerbar></headerbar> -->
            <tags></tags>
            <div class="content" :class="$store.state.contentBackground ? $store.state.contentBackground : ''">
                <el-scrollbar class="page-compoent__scroll content-scroll">
                    <transition name="move" mode="out-in">
                        <div class="keep-alive-wrap">
                            <keep-alive>
                                <router-view v-if="$route.meta.keepAlive"></router-view>
                            </keep-alive>
                            <router-view v-if="!$route.meta.keepAlive"></router-view>
                        </div>
                    </transition>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
    import headerbar from "@/components/common/headerbar/header";
    import sidebar from "@/components/common/sidebar/sidebar";
    import tags from "@/components/common/tags";
import { commonApi } from '@/api/common';

    export default {
        data() {
            return {
                sidebarList: []
            };
        },
        components: {headerbar, sidebar, tags},
        mounted() {
            Bus.$on('initPermission',()=>{
				this.updatePermission()
			})
            // 初始化权限
			this.initPermission()
        },
        methods: {
            // 初始化权限
			initPermission() {
				//获取是否是超管
				if (this.$store.state.permissionInfo.isManager == null) {
					this.getIsManager();
				}
				// 如果本地没有存储菜单栏，则初始存储
				if(this.$store.state.permissionInfo.sidebarList.length == 0) {
					this.$store.commit("changeSidebarList", this.sidebarList);
				}
			},
            // 更新权限
			updatePermission() {
				this.$store.commit('changeManager',null)
				this.$store.commit('savePermissionList',[])
				this.$store.commit('savePermissionBtnList',[])
				this.$store.commit('changeSidebarList',[])
                //回到首页
                this.$router.push('/index')
				this.initPermission()
				this.$refs.sideBar.initMenu()
				Bus.$emit('clearTags')
				// 因为有缓存,所以间隔一会,再次清除顶部标签栏
				setTimeout(()=>{
					Bus.$emit('clearTags')
				},100)
			},
            // 获取是否是超管
			getIsManager() {
				this.$EpetJs.Common.ajax('get',commonApi.isManager).then(res => {
					if(res) {
						this.$store.commit("changeManager", res.data.data);
					}
				})
			},
            changeNavView() {
                if (this.$store.state.isCollapse) {
                    this.$store.commit("changeNavView", false);
                } else {
                    this.$store.commit("changeNavView", true);
                }
            }
        },
        computed: {
            nocachePage() {
                return this.$store.state.nocachePage;
            },
            key() {
                return this.$route.fullPath;
            }
        }
    };
</script>

<style>
    .home-wrap {
        height: 100%;
    }

    .main-wrap {
        height: 100%;
        transition: margin-left 0.28s;
    }

    .coll-main {
        margin-left: 65px;
    }

    .open-main {
        margin-left: 160px;
    }

    .content {
        padding: 10px 20px 50px;
        height: 100%;
        box-sizing: border-box;
        background: #f0f0f0;
    }

    .change-nav {
        position: fixed;
        width: 13px;
        height: 80px;
        top: 50%;
    }

    .change-nav i {
        display: block;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .content .el-scrollbar__view {
        min-width: 1000px;
        overflow-x: hidden;
    }

    .change-nav i:before {
        content: "";
        background: url(../assets/images/arrow.png) 0 0 no-repeat;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .change-nav .icon-zhankai:before {
        background-position: 0 -90px;
    }

    .is-horizontal {
        display: none;
    }

    .content .is-horizontal {
        display: block;
    }
</style>
